<template>
  <v-dialog v-model="dialog" max-width="600px">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on"
            depressed
            block
            class="btn-edurent"
            color="primary"
            height="45"
      >
        Connect with Stripe
      </v-btn>
    </template>
            <v-stepper v-model="currStep" class="stripe-sign-up-steps">

            <div class="d-flex justify-end">
                <v-btn icon @click="closeDialog">
                    <v-icon size="18" color="grey">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-stepper-items>
                <v-stepper-content step="1">
                     <v-row class="justify-center ma-1">
                        <v-col cols="9" class="text-center">
                            <h4>Let's get started!</h4>
                            <div class="mt-6">
                                <v-row>
                                    <v-col class="pb-0">
                                        <p>Do you already have a bank account or debit card?</p>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <p class="font-italic">You’ll need one in order to successfully connect with Stripe and start crowdfunding</p>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn height="45" color="rgba(0,0,0,1)" class="btn-edurent font-weight-regular" outlined block @click="currStep=2">Yes, I have one</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn height="45" color="rgba(0,0,0,1)" class="btn-edurent font-weight-regular" outlined block @click="currStep=3">No, Help me open an account</v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                     </v-row>
                </v-stepper-content>
                <v-stepper-content step="2">
                    <v-row class="justify-center">
                        <v-col cols="9" class="text-center">
                            <h4>Perfect, let's continue!</h4>
                            <div class="mt-6">
                                <v-row>
                                    <v-col class="pb-0">
                                        <p>Please have your bank account or debit card information ready to complete the connection with Stripe.</p>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn height="45"
                                               color="primary"
                                               class="btn-edurent font-weight-regular"
                                               block
                                               @click="connectToStripe"
                                               :loading="isConnectingStripe"
                                        >Continue to start getting paid</v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn
                                            text
                                            depressed
                                            color="primary"
                                            class="skip-btn btn-edurent"
                                            height="45"
                                            width="163"
                                            @click="currStep = 3"
                                    >
                                        Oops, I don't have a bank account
                                    </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                     </v-row>
                </v-stepper-content>
                <v-stepper-content step="3">
                    <v-row class="justify-center">
                        <v-col cols="9" class="text-center">
                            <h4>Opening an account is quick and easy</h4>
                            <div class="mt-6">
                                <v-row>
                                    <v-col class="pb-0">
                                        <p>Select one of our recommended banks below to open a checking account and return when you are ready.</p>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn height="60" color="primary" class="btn-edurent font-weight-regular" block @click="goToBank('capitalOne')" outlined><v-img width="45" height="45" contain src="@/assets/icons/capitalOne.png" class="mr-2"></v-img></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn height="60" color="primary" class="btn-edurent font-weight-regular" block @click="goToBank('discover')" outlined><v-img width="45" height="45" contain src="@/assets/icons/discoverBank.png" class="mr-2"></v-img></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn height="60" color="primary" class="btn-edurent font-weight-regular" block @click="goToBank('chime')" outlined><v-img width="45" height="45" contain src="@/assets/icons/chimeBank.png" class="mr-2"></v-img></v-btn>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-btn
                                            text
                                            depressed
                                            color="primary"
                                            class="skip-btn btn-edurent"
                                            height="45"
                                            width="163"
                                            @click="currStep = 2"
                                    >
                                        I already have a bank account, go to next step
                                    </v-btn>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                     </v-row>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
  </v-dialog>
</template>

<script>
import PaymentService from "../services/payment.service";
export default {

  name: 'AddStripeAccountDialog',
  components: {},
  data() {
    return {
        dialog: false,
        currStep: 1,
        numSteps: 2,
        isConnectingStripe: false
    }
  },

  computed: {
    user() {
      return this.$store.getters.getUser
    }
  },

  methods: {
        closeDialog() {
            this.dialog = false
        },
        goToBank(bank) {
            let url = ""
            switch(bank) {
                case "capitalOne":
                    url = "https://www.capitalone.com/"
                    break;
                case "discover":
                    url = "https://www.discover.com/online-banking/"
                    break;
                case "chime":
                default:
                    url = "https://www.chime.com/"
                    break;
            }
            this.currStep = 1
            window.open(url)
        },
        connectToStripe: async function() {
            let hasErrors = false
            this.isConnectingStripe = true
            const accountLink = await PaymentService.getAccountLink().catch(() => {
                hasErrors = true
            })
            this.isConnectingStripe = false
            if (hasErrors || !accountLink || !accountLink.url) {
                this.$store.dispatch('getUserByToken')
                return
            }

            // redirect to accountLink.url
            window.location.href = accountLink.url
        },
  },

  filters: {

  },

  async beforeMount() {

  }
}
</script>

<style scoped>
    .stripe-sign-up-steps .v-stepper__header {
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
    }

    .stripe-sign-up-steps .v-stepper__step {
        padding-left: 0;
        padding-right: 15px;
        padding-top: 0;
        padding-bottom: 0;
        height: 4px;
    }

    .stripe-sign-up-steps .v-stepper__header {
        padding-left: 30px;
        padding-top: 30px;
        height: 38px;
    }

    .stripe-sign-up-steps .v-stepper__content {
        margin-top: -30px;
    }

    .stripe-sign-up-steps .v-stepper__step i {
        display: none;
    }

    .stripe-sign-up-steps .v-stepper__step__step {
        color: transparent !important;
        width: 54px;
        border-radius: 0;
        height: 4px;
        margin-right: 0 !important;
    }

    .stripe-sign-up-steps .v-stepper__step--inactive .v-stepper__step__step {
        background: #d8d8d8 !important;
    }

    .stripe-sign-up-steps h4 {
        font-weight: 700 !important;
        font-size: 20px !important;
    }

    .stripe-sign-up-steps .v-btn__content {
        color: #000000;
    }

    .stripe-sign-up-steps .next-btn .v-btn__content {
        color: white !important;
    }

    .stripe-sign-up-steps .skip-btn .v-btn__content {
        color: #2D76E3 !important;
    }

    .stripe-sign-up-steps .v-input--checkbox label {
        color: #000;
        font-size: 14px;
    }

    .stripe-sign-up-steps {
        border-radius: 10px !important;
    }

    .stripe-sign-up-steps .v-slider--horizontal .v-slider__track-container {
        height: 4px;
    }

    .stripe-sign-up-steps .stripe-sign-up-selected {
        background: rgba(45,118,227,0.1);
    }
</style>
